import { PctHttpErrorResponse } from '../pct-http-error-response';

export class BackendErrorWithMessageError<MESSAGE> extends PctHttpErrorResponse {
  readonly #backendError: MESSAGE;
  get backendError(): MESSAGE {
    return this.#backendError;
  }

  constructor(
    backendError: MESSAGE,
    message: string,
    status: number,
    response: string,
    headers: {
      [key: string]: any;
    },
    originalError?: Error,
  ) {
    super(message, status, response, headers, originalError);
    this.#backendError = backendError;
  }
}
